<template>
  <v-container>
    <v-data-table
      :headers="headers"
      :items="alergens"
      class="elevation-1"
      :loading="loading"
      :items-per-page="-1"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Alergeny</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-spacer>Výpis</v-spacer>
          <v-dialog
            v-model="dialog"
            max-width="650"
          >
            <template
              v-slot:activator="{ on, attrs }"
            >
              <v-btn
               @click="editedItem = defaultItem"
               color="primary"
               v-bind="attrs"
               v-on="on"
              >
                Přidat alergen
              </v-btn>
            </template>
              <AllergensForm
                :item="editedItem"
                v-if="dialog"
                @data-saved="getAlergens"
              >
              </AllergensForm>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="editAlergen(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          small
          class="mr-2"
          @click="toggleActive(item)"
        >
          {{item.active ? 'mdi-sleep' : 'mdi-sleep-off'}}
        </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="getAlergens">Reset</v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import AllergensForm from '../../forms/admin/AllergensForm'
export default {
  name: 'Allergens',
  components: { AllergensForm },
  data () {
    return {
      loading: true,
      dialog: false,
      editedItem: {},
      defaultItem: {
        id: null,
        name: null,
        active: false
      },
      headers: [
        { text: 'Název', value: 'name' },
        { text: 'Aktivní', value: 'activeStr' },
        { text: 'Akce', value: 'actions' }
      ],
      alergens: []
    }
  },
  methods: {
    getAlergens () {
      this.loading = true
      this.dialog = false
      this.$http.get('/admin/alergens')
        .then(response => {
          this.alergens = this.keysToCamelCase(response.data).map(alergen => {
            alergen.activeStr = alergen.active ? 'Aktivní' : 'Deaktivováno'
            return alergen
          })
          this.loading = false
        })
        .catch(err => console.log(err))
    },
    editAlergen (alergen) {
      this.editedItem = Object.assign({}, alergen)
      this.dialog = true
    },
    toggleActive (alergen) {
      alergen.active = !alergen.active
      this.$http.patch(`/admin/alergens/${alergen.id}`, this.keysToSnakeCase(alergen))
        .then(() => {
          this.getAlergens()
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  created () {
    this.getAlergens()
  }
}
</script>

<style scoped>

</style>
